import { AbstractSerializer } from '../../../common/AbstractSerializer';
import type { BinaryReader } from '../../../common/BinaryReader';
import Header from '../../../common/Header.js';
import type { LayerRecord } from '@visualizer/types';

export default class HeaderSerializer extends AbstractSerializer<Header> {
    public readonly version = 6;

    constructor(..._args: any[]) {
        super();
    }

    public async read(reader: BinaryReader, layer: LayerRecord = {}): Promise<Header> {
        const header = new Header();

        const readMajorVersion = reader.readUInt32();
        const readMinorVersion = reader.readUInt32();
        const readReleaseVersion = reader.readUInt32();
        header.version = `v${readMajorVersion}_${readMinorVersion}_${readReleaseVersion}`;

        header.numSensPnts = reader.readUInt32();
        layer.simKind = reader.readUInt32();

        const resultCount = reader.readUInt8();
        for (let s = 0; s < resultCount; s++) {
            reader.readString(); // Result label. Not used in this version?
        }
        layer.name = reader.readString();

        header.chunkID = reader.readUInt8();
        reader.readUInt32();
        return header;
    }
}
